export default [
  { pathname: '/system/api/box' },
  { pathname: '/system/api/container' },
  { pathname: '/system/api/grid' },
  { pathname: '/system/api/stack' },
];
